import { ProblemStatePresenter } from '@/presentation/presenters/problem/problemStatePresenter'
import { ProblemStateViewModel } from '@/presentation/viewmodels/problem/problemStateViewModel'

export function useProblemStatePresenter(
  presenter: ProblemStatePresenter = new ProblemStatePresenter(new ProblemStateViewModel())
) {
  return {
    problemId: presenter.problemId,
    nextProblemId: presenter.nextProblemId,
    prevProblemId: presenter.prevProblemId,
    setProblemId: presenter.setProblemId.bind(presenter),
    changeProblem: presenter.changeProblem.bind(presenter)
  }
}
